<form class="form-popup" [formGroup]="formGroup">
    <mat-form-field appearance="fill">
        <mat-label>Component Name</mat-label>
        <input 
            matInput 
            name="Component Name"
            autocomplete="off" 
            formControlName="component"
            />
    </mat-form-field>
    <label>Component Description</label>
    <quill-editor 
                [placeholder]="'Component Description'"
                name="Component Description" 
                formControlName="description" 
                maxlength="255" 
                required 
                [modules]="modules">
            </quill-editor>
    <mat-form-field appearance="fill">
        <mat-label>Select Parent Component</mat-label>
        <mat-select 
            formControlName="parentComponentId"
            class="fullWidth" 
            name="Parent Component" 
            >
            <mat-option *ngFor="let c of components | async" [value]="c.componentId">
                {{ c.component }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</form>
